const messages = {
  title: "About BS Plus",
  description: "About page description",
};

export default {
  messages,
};
